import React from 'react';
import TableHead from '@material-ui/core/TableHead';

const TableAppHead = ({ children }) => {
  return <TableHead>{children}</TableHead>;
};

export default TableAppHead;



// WEBPACK FOOTER //
// ./src/components/IterioApp/components/TableApp/TableAppHead.jsx